<div class="search-bar" fxFlex="auto" fxLayout="row" fxLayoutGap="10%">

    <mat-form-field class="search" style="width: 80%;">
      <mat-label >Buscar por No. Cuenta </mat-label>
      <input matInput type="text" [formControl]="query" (keydown.enter)="search()">
      <mat-error *ngIf="query.errors?.invalid">
        Cuenta  <strong>no encontrada en el sistema</strong>
      </mat-error>
    </mat-form-field>
    <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
      <button  (click)="search()">Buscar</button>
    </mat-card-actions>
  
</div>
